import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  href?: string;
}
export function CTAButton({
  children,
  className = '',
  href = 'https://checkout.aulamater.online/cart/44073141076067:1'
}: CTAButtonProps) {
  return <a href={href} className={`
        inline-flex items-center justify-center
        px-10 py-4 
        text-base font-medium text-white tracking-wider uppercase
        bg-sage-400 hover:bg-sage-500
        rounded-full
        transition-all duration-300 ease-in-out
        ${className}
      `} data-id="element-57">
      {children}
    </a>;
}